/*
* Request Product Access submission
*
**/

custom.requestAccessSubmission = (function() {

	const requestAccessClass = 'js-request-product-access';
  const addSampleRackClass = 'js-add-sample-rack';
	const accessMessageArea = 'js-request-access-message';

	function requestProductAccess(e=null) {
		e.preventDefault();
		const $button = $(this);
		const customerEmail = $button.data('email');
		const requestBrand = $button.data('brand') ? $button.data('brand') : '';
		const customerID = $button.data('id') ? $button.data('id') : '';
    const sparsID = $button.data('spars-id') ? $button.data('spars-id') : '';
    const priceLevel = $button.data('price-level') ? $button.data('price-level') : '';
    const customerCategory = $button.data('category') ? $button.data('category') : '';
    const authClass = $button.data('class') ? $button.data('class') : '';
		const postForm = $button.data('form');
		$button.addClass("js-working").addClass("js-loading").html("Sending<span class='ellipsis'><span>.</span><span>.</span><span>.</span></span>");
		if(customerEmail && postForm) {
			const handelizedBrand = requestBrand.toLowerCase().replace(/[^a-z0-9]+/g, '').replace(/-$/, '').replace(/^-/, '');
			const requestedQuery = `${handelizedBrand}${customerID}`;
			const sendData = {
				customer_id: customerID,
        spars_id: sparsID,
        price_level: priceLevel,
        customer_category: customerCategory,
        customer_auth_class: authClass,
				name: $button.data('name') ? $button.data('name') : '',
				company: $button.data('company') ? $button.data('company') : '',
				product: $button.data('product') ? $button.data('product') : '',
				brand: requestBrand,
				email: customerEmail,
				requested_tag: requestedQuery
			}
			const sendEmail = customerEmail.split('@');
			const sendEmailLocation = `https://usebasin.com/f/${postForm}.json`;
			window.MUAPP.queryBasinForm(requestedQuery, postForm).then((data) => {
        let brandName = sendData.brand;
        if (window.LoloiConfig && window.LoloiConfig.xloloi_collab && window.LoloiConfig.xloloi_collab.includes(brandName)) {
          brandName += ' × Loloi';
        }
				if(data.submissions && data.submissions.length > 0) {

					requestAccessMessage($button,`You have already requested access to purchase ${brandName} products. Please email <a href="mailto:info@loloirugs.com">info@loloirugs.com</a> for an update.`);
				} else {
					$.ajax({
						url: sendEmailLocation,
						method: "POST",
						data: sendData,
						dataType: "json"
					}).then((data) => {
						requestAccessMessage($button, `Thanks, we'll evaluate your request to purchase ${brandName} products and will be in touch.`);
					}, (err) => {
						requestAccessError($button, `Unable to submit access request. Please contact <a href="mailto:info@loloirugs.com">info@loloirugs.com</a> to request access to ${brandName}.`);
					});
				}
			}, (err) => {
				requestAccessError($button, `Unable to submit access request. Please contact <a href="mailto:info@loloirugs.com">info@loloirugs.com</a> to request access to ${brandName}.`);
			});
		} else {
			requestAccessError($button, `Your customer email seems to be missing. Please contact <a href="mailto:info@loloirugs.com">info@loloirugs.com</a> to request access to ${brandName}.`);
		}

	}

	function requestAccessMessage($el=null, message=null) {
		if(!message || !$el) return;
		const target = $el.data("message-target")
		$el.parent().addClass('hidden');
		if(target === "pdpCTAmessages") $el.parent().parent().addClass('hidden');
		$(`#${target}`).find(`.${accessMessageArea}`).html(message);
		$(`#${target}`).removeClass('hidden');
		setTimeout(function() {
			$el.text('Request Access');
			$(`#${target}`).addClass('hidden');
			$el.parent().removeClass('hidden');
			if(target === "pdpCTAmessages") $el.parent().parent().removeClass('hidden');
		}, 5000);
	}

  function sampleRequestMessage(e=null) {
    const $el = $(this);
    const target = $el.data("message-target");
    setTimeout(function() {
      $el.addClass('hidden');
      $(`#${target}`).find(`.${accessMessageArea}`).html("Loloi will follow up after your purchase so you may select your 70 free samples.");
      $(`#${target}`).removeClass('hidden');
      setTimeout(function() {
        $(`#${target}`).addClass('hidden');
        $el.removeClass('hidden');
      }, 5000);
    }, 150);
  }

	function requestAccessError ($el=null, message=null) {
		if(!message || !$el) return;
		$(`.${accessMessageArea}`).addClass('text-red');
		requestAccessMessage($el, message);
	}


	function init() {
		$('.template-product').on('click', `.${requestAccessClass}`, requestProductAccess);
		$('.quick-view-drawer').on('click', `.${requestAccessClass}`, requestProductAccess);
    $('.template-product').on('click', `.${addSampleRackClass}`, sampleRequestMessage);
    $('.quick-view-drawer').on('click', `.${addSampleRackClass}`, sampleRequestMessage);
	}

	return {
		init: init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/request-access-submission.js